export const initializing = {
  initial: 'init',
  states: {
    init: {
      initial: 'initialisingConfig',
      states: {
        initialisingConfig: {
          entry: 'handleOpenInIframe',
          invoke: {
            src: 'initialiseConfig',
            onDone: {
              target: 'checkSegmentsCookie',
              actions: ['setCookieUserCountry'],
            },
            onError: {
              target: 'checkSegmentsCookie',
            },
          },
        },
        checkSegmentsCookie: {
          invoke: {
            src: 'fetchSegmentsCookie',
            onDone: [
              {
                target: 'installingTracking',
                actions: ['checkSegmentsCookie'],
              },
            ],
          },
        },
        installingTracking: {
          entry: ['installTracking'],
          invoke: {
            src: 'initializeTrackingData',
            onDone: [
              {
                target: 'trackGamingRollout',
                actions: 'saveInitialTrackingData',
                cond: 'isRoutingEnabled',
              },
              {
                target: 'fetchDeviceInfo',
                actions: 'saveInitialTrackingData',
              },
            ],
          },
        },
        trackGamingRollout: {
          invoke: {
            src: 'trackGamingRollout',
            onDone: [
              {
                target: 'fetchDeviceInfo',
              },
            ],
          },
        },
        fetchDeviceInfo: {
          invoke: {
            src: 'fetchDeviceInfo',
            onDone: [
              {
                target: 'fetchNumberOfAllSearchGames',
                actions: [
                  {
                    type: 'save',
                    data: {
                      currentScreenSize: '$event.data.currentScreenSize',
                      deviceInfo: '$event.data.deviceInfo',
                      isFullScreen: '$event.data.isFullScreen',
                    },
                    meta: {
                      selectors: [
                        '$action.data.deviceInfo',
                        '$action.data.currentScreenSize',
                        '$action.data.isFullScreen',
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
        fetchNumberOfAllSearchGames: {
          invoke: {
            src: 'fetchNumberOfAllSearchGames',
            onDone: {
              target: 'fetchInitialPage',
              actions: [
                {
                  type: 'save',
                  data: {
                    numberOfAllSearchGames:
                      '$event.data.numberOfAllSearchGames',
                  },
                  meta: {
                    selectors: ['$action.data.numberOfAllSearchGames'],
                  },
                },
              ],
            },
          },
        },
        fetchInitialPage: {
          invoke: {
            src: 'fetchPageInfo',
            onDone: [
              {
                target: 'displayPagePreloaded',
                cond: 'isLayoutPreloadedAndNormalPage',
                actions: [
                  'updateCurrentPagePath',
                  {
                    type: 'save',
                    data: {
                      navigationLinks: '$event.data.navigationLinks',
                      subNavigationItems: '$event.data.subNavigationItems',
                      isSidebarInLayout: '$event.data.isSidebarInLayout',
                      isVideoEnabled: '$event.data.isVideoEnabled',
                      mainLayoutPath: '$event.data.mainLayoutPath',
                      controllersData: '$event.data.controllersData',
                      initialRequest: '$event.data.initialRequest',
                      currentTablesIdList: '$event.data.liveDealerTables',
                      personalizedBanners: '$event.data.personalizedBanners',
                      currentPagePath: '$event.data.currentPagePath',
                      isErrorPage: '$event.data.isErrorPage',
                      changePageAction: '',
                    },
                    meta: {
                      selectors: [
                        '$action.data.navigationLinks',
                        '$action.data.subNavigationItems',
                        '$action.data.isSidebarInLayout',
                        '$action.data.isVideoEnabled',
                        '$action.data.mainLayoutPath',
                        '$action.data.controllersData',
                        '$action.data.initialRequest',
                        '$action.data.currentTablesIdList',
                        '$action.data.personalizedBanners',
                        '$action.data.currentPagePath',
                        '$action.data.isErrorPage',
                      ],
                    },
                  },
                  {
                    type: 'batchLayoutOperations',
                    data: [
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path:
                            'components.ContentWrapper.properties.isSidebarInLayout',
                          value: '$context.isSidebarInLayout',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Layout.properties.deviceType',
                          value: '$context.deviceInfo.deviceType',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Layout.properties.deviceNative',
                          value: '$context.deviceInfo.isNative',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Layout.properties.deviceOs',
                          value: '$context.deviceInfo.deviceOs',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Layout.properties.launchStrategies',
                          value: '$context.gameLaunchStrategies',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Layout.properties.loggedIn',
                          value: '$context.user.loggedIn',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                      {
                        type: 'setLayoutProperty',
                        data: {
                          path: 'components.Modal.properties.componentVisible',
                          value: '$context.isSidebarInLayout',
                        },
                        meta: {
                          selectors: ['$action.data.value'],
                        },
                      },
                    ],
                  },
                  'updateSiteTrackingStorageInfo',
                  'updateRegistrationComponentMode',
                  'trackPageChange',
                  'updateSeo',
                  'saveSegments',
                ],
              },
              {
                target: 'displayPagePreloaded',
                cond: 'isLayoutPreloadedAndErrorPage',
                actions: [
                  'updateCurrentPagePath',
                  {
                    type: 'save',
                    data: {
                      isErrorPage: '$event.data.isErrorPage',
                      initialRequest: '$event.data.initialRequest',
                    },
                    meta: {
                      selectors: [
                        '$action.data.isErrorPage',
                        '$action.data.initialRequest',
                      ],
                    },
                  },
                ],
              },
              {
                target: 'displayPage',
                actions: [
                  'updateCurrentPagePath',
                  'updateSiteTrackingStorageInfo',
                  'updateRegistrationComponentMode',
                  {
                    type: 'save',
                    data: {
                      initialRequest: '$event.data.initialRequest',
                    },
                    meta: {
                      selectors: ['$action.data.initialRequest'],
                    },
                  },
                ],
              },
            ],
          },
        },
        displayPage: {
          entry: [
            {
              type: 'save',
              data: {
                appInitialized: true,
              },
            },
            'layout_changePageId',
          ],
        },
        displayPagePreloaded: {
          entry: [
            {
              type: 'save',
              data: {
                appInitialized: true,
              },
            },
            {
              cond: 'isSidebarVisibleOnBigScreen',
              type: ['scrollTop', 'setBodyNonScrollable'],
            },
            'layout_notifyChangeEnd',
          ],
        },
      },
    },
  },
};
